import React from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import { navActionCreators } from '../../../stores/lis-nav-store';
import { HistoricalRedirectPopup } from './lis-popup-component';

const customStyles = {
    option: (base, state) => ({
        ...base,
        fontSize: '14px',
        fontWeight: state.data.IsActive ? 'bold' : 'normal'
    }),
    control: (base) => ({
        ...base,
        fontSize: '14px',
        background: '#f1f1f1',
        border: '1px solid #d8d8d8',
        borderRadius: '0 0 5px 5px'
    }),
    menu: (base) => ({
        ...base,
        width: '245px',
        marginTop: '1px',

    }),
    menuList: (base) => ({
        ...base,
        marginTop: '1px'
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: "none"
    }),
    singleValue: (base, state) => {
        return { ...base, };
    }
}

class SessionSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selectedSession: {},
            sessionListMessage: '',
            sessionOptions: [],
            focusAnnouncement: '',
            isSessionMenuOpen: false
        };

        this.getSessions = this.getSessions.bind(this);
    }

    componentDidMount() {
        this.getSessions();
    }

    getSessions() {
        this.props.actions.getSessionList().then(() => {
            if (this.props.session.sessionList.length > 0) {
                // FORMAT DATA FOR DROPDOWN
                let sessionList = [...this.props.session.sessionList]
                sessionList.forEach(session => {
                    session.value = session.SessionID;
                    session.label = session.SessionYear + ' ' + session.DisplayName + (session.IsActive ? ' (Active)' : '');
                    if (session.SessionCode === this.props.nav.session) {
                        this.setState({
                            selectedSession: session
                        });
                    } else if (session.IsDefault && !this.props.nav.session) {
                        this.props.actions.changeSession(session.SessionCode);
                        this.setState({
                            selectedSession: session
                        });
                    }
                });
                sessionList = sessionList.reverse();
                this.setState({
                    sessionOptions: sessionList
                });
            } else {
                this.setState({
                    sessionListMessage: this.props.session.sessionListMessage
                });
            }
        });
    }

    handleChange = value => {
        if (window.env && window.env.HISTORICAL_DATA_REDIRECT && value && !value.IsDefault && value.LegacySessionID && value.SessionCode != "20242" && !this.props.login.userClaims.roles.find(x => x === "LegacyDataReader")) {
            this.setState({
                historicalSessionRedirect: (redirect) => {
                    if (redirect) {
                        let a = document.createElement('a');
                        a.target = '_blank';
                        a.href = `https://legacylis.virginia.gov/cgi-bin/legp604.exe?ses=${value.SessionCode.substring(2)}&typ=lnk&val=${value.LegacySessionID}`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                    this.setState({ historicalSessionRedirect: false })
                }
            })
            return;
        }
        if (value && value.SessionCode) {
            this.setState({
                selectedSession: this.state.sessionOptions.find(s => s.SessionCode === value.SessionCode)
            });
            this.props.actions.changeSession(value.SessionCode);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.nav.session !== this.props.nav.session || (prevState.sessionOptions.length !== this.state.sessionOptions.length && this.state.selectedSession?.SessionCode !== this.props.nav.session)) {
            const selectedSession = this.state.sessionOptions.find(option => option.SessionCode?.toString() === this.props.nav.session?.toString())
            if (selectedSession) {
                this.setState({
                    selectedSession: selectedSession
                })
            }
        }
        if (prevProps.nav.reloadSessionSelector !== this.props.nav.reloadSessionSelector && this.props.nav.reloadSessionSelector === true) {
            this.getSessions();
            this.props.actions.reloadSessionSelector(false);
        }

        if (this.props.overrideSession != "") {
            this.handleChange(this.props.overrideSession)
        }
    }

    getSelectedSessionLabel(selectedSession) {
        let newSession = { ...selectedSession } //don't modify existing session values stored at state level & used in dropdown
        if (newSession && newSession.label) {
            newSession.label = newSession.label.replace(' (Active)', '')
        }
        return newSession;
    }

    render() {
        const { sessionOptions, selectedSession } = this.state;
        const hide = this.props.nav.hideSessionSelectorPaths.find(path => new RegExp(path, 'g').test(this.props.location.pathname))

        const handleSelectEnterKey = (e, isMenuOpen) => {
            if (e.key === 'Enter' && !isMenuOpen) {
                e.preventDefault();
                const arrowDownEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    code: 'ArrowDown',
                    keyCode: 40,
                    which: 40,
                    bubbles: true
                });
                e.currentTarget.dispatchEvent(arrowDownEvent);
            }
        }

        return (
            <div className="full" id="session-select-container">
                <span className="sr-only" aria-live="assertive" style={{ position: 'absolute', left: '-9999px' }}>{this.state.focusAnnouncement}</span>
                {this.state.historicalSessionRedirect &&
                    <HistoricalRedirectPopup redirect={() => this.state.historicalSessionRedirect(true)} closePopup={() => this.state.historicalSessionRedirect(false)} />
                }
                <div className={(hide && this.props.location.pathname !== "/profile" && !this.props.location.pathname.split("/").includes("member-legislation-list")) ? "session-select-tab hidden" : "session-select-tab"}>
                    <Select
                        id="sessionSelector"
                        classNamePrefix="global-session-selector"
                        aria-label="Session Selector"
                        isSearchable={false}
                        options={sessionOptions}
                        maxMenuHeight={170}
                        value={this.getSelectedSessionLabel(selectedSession)}
                        onChange={this.handleChange}
                        styles={customStyles}
                        onFocus={() => {
                            this.setState({
                                focusAnnouncement: `Current selection is ${this.getSelectedSessionLabel(selectedSession).label}. ${sessionOptions.length} options available.`
                            })
                        }
                        }
                        onBlur={() => {
                            this.setState({
                                focusAnnouncement: ''
                            })
                        }
                        }
                        onKeyDown={(e) => handleSelectEnterKey(e, this.state.isSessionMenuOpen)}
                        onMenuOpen={() => this.setState({ isSessionMenuOpen: true })}
                        onMenuClose={() => this.setState({ isSessionMenuOpen: false })}
                    />
                </div>
                <div className="link-wrapper">
                    <Link to={`/bill-search`}>Find a Bill</Link>
                </div>
            </div>
        )

    }
};

export default connect(
    (state) => {
        const { session, nav, login } = state;
        return {
            session,
            nav,
            login
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, sessionActionCreators, navActionCreators), dispatch)
        }
    }
)(withRouter(SessionSelector))
